import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  InputAdornment,
  IconButton,
  Drawer,
  Divider,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

const API_BASE = process.env.REACT_APP_API_BASE;

// const initialMock = [
//   {
//     id: 1,
//     name: 'Anita Patil',
//     gender: 'Female',
//     mobile: '9822001122',
//     aadhar: '1111-2222-3333',
//     vidhansabha: 'Other',
//     taluka: 'Khanapur',
//     district: 'Satara',
//     village: 'Kond',
//     epic_no: 'EPC123456',
//     booth_no: '45',
//     form_date: '2025-12-10',
//     ack_no: 'ACK-0001',
//     wfc_date: '2025-12-12',
//     wfc_location: 'Banawadi',
//     wfc_remarks: 'Visited and guided',
//     operator: 'Operator A',
//   },
// ];

export default function NewForm({ userid, user }) {
  const isAdmin = user?.user_role === 'ADMIN';
  const [records, setRecords] = useState([]);

  useEffect(() => {
    fetchRecords();
  }, []);

  const fetchRecords = async () => {
    try {
      const res = await fetch(`${API_BASE}/new-form-records`, {
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
      const data = await res.json();
      setRecords((data || []).map(mapFromApi));
    } catch (err) {
      console.error('Error fetching records:', err);
    }
  };
  const [form, setForm] = useState({
    id: null,
    userid: null,
    name: '',
    gender: 'Male',
    mobile: '',
    whatsapp_no: '',
    verification_date: '',
    aadhar: '',
    epic_no: '',
    vidhansabha: 'Karad South',
    village: '',
    booth_no: '',
    gan_name: '',
    zp_name: '',
    reference: '',
    taluka: '',
    district: '',
    form_date: '',
    ack_no: '',
    wfc_date: '',
    wfc_location: 'Karad',
    wfc_other_location: '',
    wfc_remarks: '',
    operator: '',
    payment_status: 'UNPAID',
    cash_amount: '',
    online_amount: '',
    card_no: '',
    approved_date: '',
    card_vatap_date: '',
    gift_type: 'NA',
    potsdate: '',
    boxdate: '',
    newkitdate: '',
    NextRenewalDate: '',
    form_status: 'Submitted',
    formowner: '',
  });
  const [editing, setEditing] = useState(false);
  const [filters, setFilters] = useState({
    name: '',
    mobile: '',
    aadhar: '',
    village: '',
    reference: '',
    form_date: '',
    ack_no: '',
    payment_status: '',
    form_status: '',
    operator: '',
    form_date_from: '',
    form_date_to: '',
    next_renewal_from: '',
    next_renewal_to: '',
    visit_date_from: '',
    visit_date_to: '',
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((s) => {
      let next = { ...s, [name]: value };
      if (name === 'wfc_location' && value !== 'Other') {
        next.wfc_other_location = '';
      }
      return next;
    });
  }

  function mapFromApi(a) {
    const toInputDate = (d) => {
      if (!d) return '';
      // Check for valid date string or date object
      const dateStr = String(d).slice(0, 10);
      if (dateStr.startsWith('-') || dateStr === '0000-00-00') return '';
      return dateStr;
    };
    return {
      ...a,
      id: a.id,
      name: a.name || '',
      gender: a.gender || 'Male',
      mobile: a.mobile || '',
      whatsapp_no: a.whatsapp_no || '',
      verification_date: toInputDate(a.verification_date),
      aadhar: a.aadhar || '',
      epic_no: a.epic_no || '',
      vidhansabha: a.vidhansabha || 'Karad South',
      village: a.village || '',
      booth_no: a.booth_no || '',
      gan_name: a.gan_name || '',
      zp_name: a.zp_name || '',
      reference: a.reference || '',
      taluka: a.taluka || '',
      district: a.district || '',
      form_date: toInputDate(a.form_date),
      ack_no: a.ack_no || '',
      wfc_date: toInputDate(a.wfc_date),
      wfc_location: a.wfc_location || 'Karad',
      wfc_other_location: a.wfc_other_location || '',
      wfc_remarks: a.wfc_remarks || '',
      operator: a.operator || '',
      payment_status: a.payment_status || 'UNPAID',
      cash_amount: a.cash_amount || '',
      online_amount: a.online_amount || '',
      card_no: a.card_no || '',
      approved_date: toInputDate(a.approved_date),
      card_vatap_date: toInputDate(a.card_vatap_date),
      gift_type: a.gift_type || 'NA',
      potsdate: toInputDate(a.potsdate),
      boxdate: toInputDate(a.boxdate),
      newkitdate: toInputDate(a.newkitdate),
      NextRenewalDate: toInputDate(a.NextRenewalDate),
      form_status: a.form_status || 'Submitted',
      formowner: a.formowner || '',
    };
  }

  function mapToApi(f, uid) {
    const data = { ...f, userid: uid };
    // Convert empty strings to null for database compatibility
    // Convert empty strings to null for database compatibility
    [
      'form_date', 'wfc_date', 'verification_date', 'cash_amount', 'online_amount',
      'approved_date', 'card_vatap_date', 'NextRenewalDate',
      'gift_type', 'form_status', 'card_no',
      'potsdate', 'boxdate', 'newkitdate'
    ].forEach(key => {
      if (data[key] === '' || data[key] === 'NA') {
        if (key === 'gift_type' || key === 'form_status') {
          if (data[key] === '') data[key] = null;
        } else {
          data[key] = null;
        }
      }
    });

    // Handle formowner specially if it's currently called form_owner in form state
    if (data.form_owner !== undefined && data.formowner === '') {
      data.formowner = data.form_owner;
    }
    delete data.form_owner;

    return data;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const url = form.id ? `${API_BASE}/new-form-records/${form.id}` : `${API_BASE}/new-form-records`;
    const method = form.id ? 'PUT' : 'POST';

    try {
      // Create a copy to modify
      const data = mapToApi(form, userid);
      const payload = { ...data };

      // Final sanity check for dates
      ['approved_date', 'card_vatap_date', 'NextRenewalDate', 'verification_date', 'form_date', 'wfc_date', 'potsdate', 'boxdate', 'newkitdate'].forEach(key => {
        if (payload[key] && (String(payload[key]).startsWith('-') || String(payload[key]).startsWith('0000'))) {
          payload[key] = null;
        }
      });

      console.log('Sending data:', payload);
      // Include user role so backend can enforce lock check
      payload._user_role = user?.user_role || '';

      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const errData = await res.json();
        console.error('Server Error:', errData);
        let msg = errData.message || 'Save failed';
        if (errData.errors) {
          msg += '\n' + JSON.stringify(errData.errors, null, 2);
        }
        throw new Error(msg);
      }

      await fetchRecords();
      resetForm();
      setDrawerOpen(false);
    } catch (err) {
      console.error('Error saving record:', err);
      alert('Error saving record: ' + err.message);
    }
  }

  function handleEdit(id) {
    const rec = records.find((r) => r.id === id);
    if (!rec) return;
    // Non-admin cannot open locked records
    if (!isAdmin && rec.is_locked && !rec.unlock_granted_by) {
      alert('This record is locked. Please ask an admin to unlock it first.');
      return;
    }
    setForm({ ...rec });
    setEditing(true);
    setDrawerOpen(true);
  }

  async function handleToggleLock(id) {
    try {
      const res = await fetch(`${API_BASE}/new-form-records/${id}/toggle-lock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ admin_name: user?.namename || 'admin' })
      });
      if (!res.ok) throw new Error('Toggle lock failed');
      await fetchRecords();
    } catch (err) {
      alert('Error toggling lock: ' + err.message);
    }
  }

  async function handleDelete(id) {
    const rec = records.find((r) => r.id === id);
    if (!rec) return;
    // Non-admin cannot delete locked records
    if (!isAdmin && rec.is_locked && !rec.unlock_granted_by) {
      alert('This record is locked. Please ask an admin to unlock it first.');
      return;
    }

    if (!window.confirm('Delete this record?')) return;
    try {
      const res = await fetch(`${API_BASE}/new-form-records/${id}`, {
        method: 'DELETE',
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) throw new Error('Delete failed');
      await fetchRecords();
    } catch (err) {
      console.error('Error deleting record:', err);
      alert('Error deleting record');
    }
  }

  const handleWhatsAppReminder = (record) => {
    const number = record.whatsapp_no || record.mobile;
    if (!number) {
      alert('No WhatsApp number or mobile number available');
      return;
    }
    // Remove non-digit characters
    const cleanNumber = number.replace(/\D/g, '');
    const formattedNumber = cleanNumber.length === 10 ? `91${cleanNumber}` : cleanNumber;
    const message = `Hello ${record.name}, your renewal for Workers Org is due on ${formatDate(record.NextRenewalDate)}. Please contact us for further details.`;
    const url = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const getRenewalStatusColor = (dateStr) => {
    if (!dateStr) return 'default';
    const renewalDate = new Date(dateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const diffTime = renewalDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return 'error'; // Overdue
    if (diffDays <= 30) return 'warning'; // Due soon
    return 'success'; // Safe
  };

  function handleFilterChange(e) {
    const { name, value } = e.target;
    setFilters((f) => ({ ...f, [name]: value }));
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const parts = dateStr.split('-');
    if (parts.length !== 3) return dateStr;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  };

  const filteredRecords = React.useMemo(() => {
    const m = (val = '') => (val == null ? '' : String(val).toLowerCase());

    const isDateInRange = (dateStr, fromDate, toDate) => {
      if (!fromDate && !toDate) return true;
      if (!dateStr) return false;
      const date = new Date(dateStr);
      if (fromDate) {
        const from = new Date(fromDate);
        if (date < from) return false;
      }
      if (toDate) {
        const to = new Date(toDate);
        if (date > to) return false;
      }
      return true;
    };

    return records.filter((r) => (
      m(r.name).includes(m(filters.name)) &&
      m(r.mobile).includes(m(filters.mobile)) &&
      m(r.aadhar).includes(m(filters.aadhar)) &&
      m(r.village).includes(m(filters.village)) &&
      m(r.reference).includes(m(filters.reference)) &&
      (filters.payment_status === '' || r.payment_status === filters.payment_status) &&
      (filters.form_status === '' || r.form_status === filters.form_status) &&
      isDateInRange(r.form_date, filters.form_date_from, filters.form_date_to) &&
      isDateInRange(r.NextRenewalDate, filters.next_renewal_from, filters.next_renewal_to) &&
      isDateInRange(r.wfc_date, filters.visit_date_from, filters.visit_date_to)
    ));
  }, [records, filters]);

  const overdueCount = React.useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return records.filter(r => r.NextRenewalDate && new Date(r.NextRenewalDate) < today).length;
  }, [records]);

  function resetForm() {
    setForm({
      id: null,
      userid: null,
      name: '',
      gender: 'Male',
      mobile: '',
      whatsapp_no: '',
      verification_date: '',
      aadhar: '',
      epic_no: '',
      vidhansabha: 'Karad South',
      village: '',
      booth_no: '',
      gan_name: '',
      zp_name: '',
      reference: '',
      taluka: '',
      district: '',
      form_date: '',
      ack_no: '',
      wfc_date: '',
      wfc_location: 'Karad',
      wfc_other_location: '',
      wfc_remarks: '',
      operator: '',
      payment_status: 'UNPAID',
      cash_amount: '',
      online_amount: '',
      card_no: '',
      approved_date: '',
      card_vatap_date: '',
      gift_type: 'NA',
      potsdate: '',
      boxdate: '',
      newkitdate: '',
      NextRenewalDate: '',
      form_status: 'Submitted',
      formowner: '',
    });
    setEditing(false);
    setDrawerOpen(false);
  }

  return (
    <Box sx={{ p: 1 }}>
      <Paper sx={{ p: 2, bgcolor: 'white' }} elevation={4}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
          <Typography variant="h6" sx={{ color: '#0b4a6f', flexGrow: 1, fontWeight: 'bold' }}>New Form Records</Typography>
          {overdueCount > 0 && (
            <Chip
              label={`${overdueCount} Overdue Renewals`}
              color="error"
              variant="filled"
              size="small"
              sx={{ fontWeight: 'bold', animation: 'pulse 2s infinite' }}
            />
          )}
          <Chip label={`${records.length} records`} color="primary" variant="outlined" size="small" />
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => { resetForm(); setDrawerOpen(true); }}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 'bold' }}
          >
            Add New Form
          </Button>
        </Box>

        <TableContainer sx={{ maxHeight: 'calc(100vh - 200px)', border: '1px solid #e0e0e0', borderRadius: 1 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {['Name', 'Mobile', 'Aadhar', 'Reference / Form owner', 'Form Date', 'Form Status', 'Next Renewal', 'Pay Status', 'Visit.Date', 'Actions'].map((h) => (
                  <TableCell key={h} sx={{ bgcolor: '#0b4a6f', color: 'white', fontWeight: 'bold', py: 1.5 }}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }}><TextField size="small" variant="standard" name="name" value={filters.name} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black' }} InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" color="primary" /></InputAdornment>, disableUnderline: true }} placeholder="Search..." /></TableCell>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }}><TextField size="small" variant="standard" name="mobile" value={filters.mobile} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black' }} InputProps={{ disableUnderline: true }} placeholder="Search..." /></TableCell>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }}><TextField size="small" variant="standard" name="aadhar" value={filters.aadhar} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black' }} InputProps={{ disableUnderline: true }} placeholder="Search..." /></TableCell>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }}><TextField size="small" variant="standard" name="reference" value={filters.reference} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black' }} InputProps={{ disableUnderline: true }} placeholder="Search..." /></TableCell>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }}>
                  <Stack spacing={0.5}>
                    <TextField size="small" variant="standard" type="date" name="form_date_from" value={filters.form_date_from} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black', fontSize: '10px' }} InputProps={{ disableUnderline: true }} title="From" />
                    <TextField size="small" variant="standard" type="date" name="form_date_to" value={filters.form_date_to} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black', fontSize: '10px' }} InputProps={{ disableUnderline: true }} title="To" />
                  </Stack>
                </TableCell>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }}>
                  <Select size="small" variant="standard" name="form_status" value={filters.form_status || ''} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black', minWidth: 80 }}>
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="Submitted">Submitted</MenuItem>
                    <MenuItem value="Accepted">Accepted</MenuItem>
                    <MenuItem value="Rejected">Rejected</MenuItem>
                    <MenuItem value="Re-submitted">Re-submitted</MenuItem>
                    <MenuItem value="Received">Received</MenuItem>
                    <MenuItem value="Un-Received">Un-Received</MenuItem>
                  </Select>
                </TableCell>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }}>
                  <Stack spacing={0.5}>
                    <TextField size="small" variant="standard" type="date" name="next_renewal_from" value={filters.next_renewal_from} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black', fontSize: '10px' }} InputProps={{ disableUnderline: true }} title="From" />
                    <TextField size="small" variant="standard" type="date" name="next_renewal_to" value={filters.next_renewal_to} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black', fontSize: '10px' }} InputProps={{ disableUnderline: true }} title="To" />
                  </Stack>
                </TableCell>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }}>
                  <Select size="small" variant="standard" name="payment_status" value={filters.payment_status || ''} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black', minWidth: 80 }}>
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="PAID">PAID</MenuItem>
                    <MenuItem value="UNPAID">UNPAID</MenuItem>
                  </Select>
                </TableCell>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }}>
                  <Stack spacing={0.5}>
                    <TextField size="small" variant="standard" type="date" name="visit_date_from" value={filters.visit_date_from} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black', fontSize: '10px' }} InputProps={{ disableUnderline: true }} title="From" />
                    <TextField size="small" variant="standard" type="date" name="visit_date_to" value={filters.visit_date_to} onChange={handleFilterChange} sx={{ bgcolor: 'white', borderRadius: 1, px: 0.5, border: '1px solid black', fontSize: '10px' }} InputProps={{ disableUnderline: true }} title="To" />
                  </Stack>
                </TableCell>
                <TableCell sx={{ bgcolor: '#e1f5fe', py: 1 }} />
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRecords.map((r) => (
                <TableRow key={r.id} hover sx={{ '&:nth-of-type(even)': { bgcolor: '#fafafa' } }}>
                  <TableCell sx={{ fontWeight: 500 }}>{r.name}</TableCell>
                  <TableCell>{r.mobile}</TableCell>
                  <TableCell>{r.aadhar}</TableCell>
                  <TableCell>{r.reference}{r.formowner ? ` / ${r.formowner}` : ''}</TableCell>
                  <TableCell>{formatDate(r.form_date)}</TableCell>
                  <TableCell>
                    <Chip
                      label={r.form_status}
                      size="small"
                      color={
                        r.form_status === 'Accepted' || r.form_status === 'Received' ? 'success' :
                          r.form_status === 'Rejected' || r.form_status === 'Un-Received' ? 'error' :
                            'primary'
                      }
                    />
                  </TableCell>
                  <TableCell>
                    {r.NextRenewalDate ? (
                      <Chip
                        label={formatDate(r.NextRenewalDate)}
                        size="small"
                        color={getRenewalStatusColor(r.NextRenewalDate)}
                        variant="soft"
                        sx={{ fontWeight: 'bold' }}
                      />
                    ) : '-'}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={r.payment_status}
                      size="small"
                      color={r.payment_status === 'PAID' ? 'success' : 'error'}
                    />
                  </TableCell>
                  <TableCell>{formatDate(r.wfc_date)}</TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                      <IconButton size="small" color="success" onClick={() => handleWhatsAppReminder(r)} sx={{ bgcolor: '#e8f5e9', '&:hover': { bgcolor: '#c8e6c9' } }} title="Send WhatsApp Reminder">
                        <WhatsAppIcon fontSize="small" />
                      </IconButton>
                      {/* Lock/Unlock button — admin only */}
                      {isAdmin && (
                        <IconButton
                          size="small"
                          onClick={() => handleToggleLock(r.id)}
                          title={r.unlock_granted_by ? `Unlock granted by ${r.unlock_granted_by} — click to re-lock` : 'Click to unlock for editing'}
                          sx={{ bgcolor: r.unlock_granted_by ? '#fff3e0' : '#fce4ec', '&:hover': { bgcolor: r.unlock_granted_by ? '#ffe0b2' : '#f8bbd0' } }}
                        >
                          {r.unlock_granted_by ? <LockOpenIcon fontSize="small" color="warning" /> : <LockIcon fontSize="small" color="error" />}
                        </IconButton>
                      )}
                      {/* Edit button */}
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => handleEdit(r.id)}
                        disabled={!isAdmin && r.is_locked && !r.unlock_granted_by}
                        title={!isAdmin && r.is_locked && !r.unlock_granted_by ? 'Record is locked' : 'Edit'}
                        sx={{ bgcolor: '#e3f2fd', '&:hover': { bgcolor: '#bbdefb' }, opacity: (!isAdmin && r.is_locked && !r.unlock_granted_by) ? 0.4 : 1 }}
                      >
                        {(!isAdmin && r.is_locked && !r.unlock_granted_by) ? <LockIcon fontSize="small" /> : <EditIcon fontSize="small" />}
                      </IconButton>
                      {/* Delete button */}
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleDelete(r.id)}
                        disabled={!isAdmin && r.is_locked && !r.unlock_granted_by}
                        title={!isAdmin && r.is_locked && !r.unlock_granted_by ? 'Record is locked' : 'Delete'}
                        sx={{ bgcolor: '#ffebee', '&:hover': { bgcolor: '#ffcdd2' }, opacity: (!isAdmin && r.is_locked && !r.unlock_granted_by) ? 0.4 : 1 }}
                      >
                        {(!isAdmin && r.is_locked && !r.unlock_granted_by) ? <LockIcon fontSize="small" /> : <DeleteIcon fontSize="small" />}
                      </IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box component="form" onSubmit={handleSubmit} sx={{ width: { xs: '100vw', sm: 500 }, p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ color: '#0b4a6f', flexGrow: 1, fontWeight: 'bold' }}>
              {editing ? 'Edit Record' : 'Add New Record'}
            </Typography>
            <IconButton onClick={() => setDrawerOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 2 }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, overflowY: 'auto', flexGrow: 1, pr: 1 }}>
            <TextField label="Worker's Name" name="name" value={form.name} onChange={handleChange} required fullWidth variant="outlined" />

            <FormControl fullWidth>
              <InputLabel id="gender-label">Gender</InputLabel>
              <Select labelId="gender-label" label="Gender" name="gender" value={form.gender} onChange={handleChange}>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
              </Select>
            </FormControl>

            <TextField label="Mobile No" name="mobile" value={form.mobile} onChange={handleChange} fullWidth variant="outlined" />
            <TextField label="Whatsapp Mobile Number" name="whatsapp_no" value={form.whatsapp_no} onChange={handleChange} fullWidth variant="outlined" />
            <TextField label="Aadhar No" name="aadhar" value={form.aadhar} onChange={handleChange} fullWidth variant="outlined" />
            {/* <TextField label="EPIC No" name="epic_no" value={form.epic_no} onChange={handleChange} fullWidth variant="outlined" /> */}

            {/* 
            <FormControl fullWidth sx={{ display: 'none' }}>
              <InputLabel id="vidh-label">Vidhansabha</InputLabel>
              <Select labelId="vidh-label" label="Vidhansabha" name="vidhansabha" value={form.vidhansabha} onChange={handleChange}>
                <MenuItem value="Karad South">Karad South</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>
            */}


            <TextField label="Village" name="village" value={form.village} onChange={handleChange} fullWidth variant="outlined" />
            <TextField label="Taluka" name="taluka" value={form.taluka} onChange={handleChange} fullWidth variant="outlined" />
            <TextField label="District" name="district" value={form.district} onChange={handleChange} fullWidth variant="outlined" />

            <FormControl fullWidth variant="outlined">
              <InputLabel id="formowner-label">Form Owner</InputLabel>
              <Select labelId="formowner-label" label="Form Owner" name="formowner" value={form.formowner} onChange={handleChange}>
                <MenuItem value="NITIN SIR">NITIN SIR</MenuItem>
                <MenuItem value="KUMBHAR MADAM">KUMBHAR MADAM</MenuItem>
                <MenuItem value="KAMBALE MADAM">KAMBALE MADAM</MenuItem>
                <MenuItem value="TAMBAVE OFFICE">TAMBAVE OFFICE</MenuItem>
              </Select>
            </FormControl>
            <TextField label="Reference" name="reference" value={form.reference} onChange={handleChange} fullWidth variant="outlined" />

            <TextField label="Form Online Date" name="form_date" type="date" InputLabelProps={{ shrink: true }} value={form.form_date} onChange={handleChange} fullWidth variant="outlined" />
            <TextField label="WFC Visit Date" name="wfc_date" type="date" InputLabelProps={{ shrink: true }} value={form.wfc_date} onChange={handleChange} fullWidth variant="outlined" />
            <TextField label="Acknowledgement No." name="ack_no" value={form.ack_no} onChange={handleChange} fullWidth variant="outlined" />

            <FormControl fullWidth>
              <InputLabel id="wfc-loc-label">WFC Visit Location</InputLabel>
              <Select labelId="wfc-loc-label" label="WFC Visit Location" name="wfc_location" value={form.wfc_location} onChange={handleChange}>
                <MenuItem value="Karad">Karad</MenuItem>
                <MenuItem value="North Karad">North Karad</MenuItem>
                <MenuItem value="Patan">Patan</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>

            {form.wfc_location === 'Other' && (
              <TextField label="Other WFC Location" name="wfc_other_location" value={form.wfc_other_location} onChange={handleChange} fullWidth variant="outlined" />
            )}

            <TextField label="WFC Visit Remarks" name="wfc_remarks" value={form.wfc_remarks} onChange={handleChange} multiline rows={3} fullWidth variant="outlined" />

            <TextField label="Operator Name" name="operator" value={form.operator} onChange={handleChange} fullWidth variant="outlined" />

            <Box sx={{ border: '1px solid #ddd', p: 2, borderRadius: 1, bgcolor: '#f9f9f9', display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography variant="subtitle2" sx={{ color: '#0b4a6f', fontWeight: 'bold' }}>Card & Gift Details</Typography>
              <TextField label="MH No." name="card_no" value={form.card_no} onChange={handleChange} fullWidth variant="outlined" />
              <TextField label="Approved Date" name="approved_date" type="date" InputLabelProps={{ shrink: true }} value={form.approved_date} onChange={handleChange} fullWidth variant="outlined" />
              <TextField label="Card Vatap Date" name="card_vatap_date" type="date" InputLabelProps={{ shrink: true }} value={form.card_vatap_date} onChange={handleChange} fullWidth variant="outlined" />

              {/* <FormControl fullWidth>
                <InputLabel id="gift-type-label">Gift Type</InputLabel>
                <Select labelId="gift-type-label" label="Gift Type" name="gift_type" value={form.gift_type} onChange={handleChange}>
                  <MenuItem value="NA">NA</MenuItem>
                  <MenuItem value="Pots (Cookwares)">Pots (Cookwares)</MenuItem>
                  <MenuItem value="Box">Box</MenuItem>
                  <MenuItem value="New Kit">New Kit</MenuItem>
                </Select>
              </FormControl> */}

              <TextField label="Pots Date" name="potsdate" type="date" InputLabelProps={{ shrink: true }} value={form.potsdate} onChange={handleChange} fullWidth variant="outlined" />
              <TextField label="Box Date" name="boxdate" type="date" InputLabelProps={{ shrink: true }} value={form.boxdate} onChange={handleChange} fullWidth variant="outlined" />
              <TextField label="New Kit Date" name="newkitdate" type="date" InputLabelProps={{ shrink: true }} value={form.newkitdate} onChange={handleChange} fullWidth variant="outlined" />
            </Box>

            <Box sx={{ border: '1px solid #ddd', p: 2, borderRadius: 1, bgcolor: '#f9f9f9', display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography variant="subtitle2" sx={{ color: '#0b4a6f', fontWeight: 'bold' }}>Status & Renewal</Typography>

              <FormControl fullWidth>
                <InputLabel id="form-status-label">Form Status</InputLabel>
                <Select labelId="form-status-label" label="Form Status" name="form_status" value={form.form_status} onChange={handleChange}>
                  <MenuItem value="Submitted">Submitted</MenuItem>
                  <MenuItem value="Accepted">Accepted</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                  <MenuItem value="Re-submitted">Re-submitted</MenuItem>
                  <MenuItem value="Received">Received</MenuItem>
                  <MenuItem value="Un-Received">Un-Received</MenuItem>
                </Select>
              </FormControl>

              <TextField label="Next Renewal Date" name="NextRenewalDate" type="date" InputLabelProps={{ shrink: true }} value={form.NextRenewalDate} onChange={handleChange} fullWidth variant="outlined" />
            </Box>

            <Box sx={{ border: '1px solid #ddd', p: 2, borderRadius: 1, bgcolor: '#f9f9f9' }}>
              <Typography variant="subtitle2" sx={{ mb: 2, color: '#0b4a6f', fontWeight: 'bold' }}>Payment Details</Typography>
              <Stack spacing={2}>
                <FormControl fullWidth>
                  <InputLabel id="payment-status-label">Payment Status</InputLabel>
                  <Select labelId="payment-status-label" label="Payment Status" name="payment_status" value={form.payment_status} onChange={handleChange}>
                    <MenuItem value="PAID">PAID</MenuItem>
                    <MenuItem value="UNPAID">UNPAID</MenuItem>
                  </Select>
                </FormControl>

                <Stack direction="row" spacing={2}>
                  <TextField
                    label="Cash Amount Rs."
                    name="cash_amount"
                    type="number"
                    value={form.cash_amount}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                    }}
                  />
                  <TextField
                    label="Online Amount Rs."
                    name="online_amount"
                    type="number"
                    value={form.online_amount}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                    }}
                  />
                </Stack>

                <TextField label="Payment Date" name="verification_date" type="date" InputLabelProps={{ shrink: true }} value={form.verification_date} onChange={handleChange} fullWidth variant="outlined" />

              </Stack>
            </Box>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Stack direction="row" spacing={2}>
            <Button type="submit" variant="contained" color="primary" fullWidth size="large" sx={{ borderRadius: 2 }}>
              {editing ? 'Update' : 'Save'}
            </Button>
            <Button variant="outlined" onClick={resetForm} fullWidth size="large" sx={{ borderRadius: 2 }}>
              Reset
            </Button>
          </Stack>
        </Box>
      </Drawer>
    </Box>
  );
}
